import { createSlice } from "@reduxjs/toolkit";

const addModalAnswerQuestionCategorySlice = createSlice({
  name: "addModalAnswerQuestionCategory",
  initialState: {
    isOpen: false,
    error: null,
  },
  reducers: {
    openModal: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
});

export const { openModal, closeModal } = addModalAnswerQuestionCategorySlice.actions;
export default addModalAnswerQuestionCategorySlice.reducer;
